// extracted by mini-css-extract-plugin
var _1 = "mg4IC";
var _2 = "C7i87";
var _3 = "_3xHPO";
var _4 = "TTuW1";
export { _1 as "base", _2 as "box", _3 as "leftView", _4 as "rightView" }
